import { SowListItem } from '../../../../../../types/ProjectManagement/Project/ProjectView/SOW/sowTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../../utils/apiUtils'
import { sowApiConfig, AllowedHttpMethods } from '../../../../apiList'

const uploadProjectSOW = async (
  file: File,
  projectId: number | string,
): Promise<number | undefined> => {
  const formData = new FormData()
  formData.append('file', file)

  const requestConfig = getAuthenticatedRequestConfig({
    url: sowApiConfig.uploadProjectSOW,
    method: AllowedHttpMethods.post,
    data: formData,
    params: { projectId },
    additionalHeaders: { 'Content-Type': 'multipart/form-data' },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const downloadSOWFile = async (
  projectId: number | string,
  sowId?: number | string,
): Promise<Blob | undefined> => {
  const params: Record<string, number | string | undefined> = { projectId }
  if (sowId !== undefined) params.id = sowId

  const requestConfig = getAuthenticatedRequestConfig({
    url: sowApiConfig.downloadSOWFile,
    method: AllowedHttpMethods.get,
    params,
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getSowFileData = async (
  projectId: number | string,
): Promise<SowListItem[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: sowApiConfig.getSowFileData,
    method: AllowedHttpMethods.get,
    params: { id: projectId },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const sowApi = {
  uploadProjectSOW,
  downloadSOWFile,
  getSowFileData,
}

export default sowApi
